import { Network } from "@/network";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Log } from "@/util";

class ScheduleReportModel {
    private static sInstance: ScheduleReportModel;

    public static get instance(): ScheduleReportModel {
        if (!ScheduleReportModel.sInstance) {
            ScheduleReportModel.sInstance = new ScheduleReportModel();
        }

        return ScheduleReportModel.sInstance;
    }

    // 新增
    public async add(query: Uint8Array): Promise<number> {
        let ec = TCBReceiptApi.Protobuf.ErrorCode.EC_NONE;

        await Network.sendAPI("/api/front/schedule_report/add", "post", query)
            .then(rawResponse => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );

                console.log(response);
                ec = response.errorCode;
            })
            .catch(error => {
                Log.error(error);
            });

        return ec;
    }

    public async getReportList(): Promise<TCBReceiptApi.Protobuf.ScheduleReportList> {
        let list = TCBReceiptApi.Protobuf.ScheduleReportList.create();

        await Network.sendAPI(
            "/api/front/schedule_report/get_list",
            "post"
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );

                list = TCBReceiptApi.Protobuf.ScheduleReportList.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });

        return list;
    }

    public async downloadFile(queryString: string): Promise<void> {
        const uri = "/api/front/schedule_report/get_file?" + queryString;
        await Network.downloadFile(uri);
    }
}

const scheduleReportModel = ScheduleReportModel.instance;

export { scheduleReportModel as ScheduleReportModel };
